import React, {useEffect, useImperativeHandle} from 'react';
import dayjs from 'dayjs';

import {areEqual} from '../../../../helpers';
import Icons from '../../../../assets/svgs/icons';

const CALLER = 'SUCESSO';

const Sucesso = ({position, current, checkAdvance, extraData, prevData, corPrimaria}) => {
  useImperativeHandle(ref, () => ({values: () => ({caller: CALLER, data: {}})}));

  useEffect(() => {
    if (current === position) checkAdvance({caller: CALLER, status: true});
  });

  return (
    <div className="mobileContent successScrenn">
      <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
        <Icons name="check" size="35px" className="mr-2" color={!!corPrimaria ? corPrimaria : '#34619E'} />
        Sucesso!
      </h1>
      <p>Número da proposta: {extraData.segurado?.numero_proposta}</p>
      <p>
        Proposta transmitida em {dayjs().format('DD/MM/YYYY')} às {dayjs().format('HH:mm')}
      </p>
      <p>
        {extraData.segurado?.id_projeto === 6
          ? ' A proposta do seguro de sua scooter/moto elétrica foi recebida com sucesso e já está em análise. Em até 2 dias úteis você receberá um retorno referente a contratação, enquanto isso sua scooter/moto elétrica está com cobertura securitária.'
          : extraData.segurado?.segurado_bicicletas[0]?.modalidade_bicicleta.id >= 6
          ? ' A proposta do seguro de seu(s) equipamento(s) foi recebida com sucesso e já está em análise. Em até 2 dias úteis você receberá um retorno referente a contratação, enquanto isso seu equipamento está com cobertura securitária.'
          : ' A proposta do seguro de sua(s) bike(s) foi recebida com sucesso e já está em análise. Em até 2 dias úteis você receberá um retorno referente a contratação, enquanto isso sua bike está com cobertura securitária.'}
      </p>
      <span style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>
        {extraData.segurado?.segurado_bicicletas[0]?.modalidade_bicicleta.id >= 6 ? 'Boas aventuras :)' : 'Boas pedaladas :)'}
      </span>
    </div>
  );
};

export default React.memo(Sucesso, areEqual());
export const ref = React.createRef();
